import React from 'react';

/**
 * Underline-style view tabs.
 */
const ViewTabs = ({ tabs = [], activeId, onChange, className = '' }) => (
  <div
    className={`flex items-center gap-1 border-b border-secondary-200 dark:border-secondary-700 ${className}`}
    role="tablist"
  >
    {tabs.map((tab) => {
      const active = tab.id === activeId;
      const Icon = tab.icon;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange?.(tab.id)}
          className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-all duration-150 border-b-2 -mb-px ${
            active
              ? 'border-primary-600 text-primary-700 dark:text-primary-300'
              : 'border-transparent text-secondary-500 hover:text-secondary-800 dark:hover:text-secondary-200'
          }`}
        >
          {Icon && <Icon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />}
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default ViewTabs;
